export const validateHtmlContent = (content) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(content, "text/html")
    const hasIframe = !!doc.querySelector("iframe")

    return !hasIframe
}

const cleanAdvancedEditorHtml = (htmlContent) => {
    /**
     * Takes in htmlContent, clean it of all tags, and returns just the text with no spaces between characters.
     *
     * 1. Get the text content after the '</head>' - .split('</head>')[1]
     * 2. Remove all new lines and tabs and whitespace - .replace(/\n/g, "").replace(/\t/g, "").replace(/\s/g, "")
     * 3. Remove all tags - .replace(/<.+?>/g, "")
     *      a. In regards to 'conatinsImagesOnly', this will remove <img> tags
     */
    return htmlContent
        .split("</head>")[1]
        .replace(/\n/g, "")
        .replace(/\t/g, "")
        .replace(/\s/g, "")
        .replace(/<.+?>/g, "")
}

export const containsImagesOnly = (patchedFields) => {
    /**
     * Checks that the html_content contains more than just images.
     *
     * For simple editor, removes all <img> tags and all tags and checks if the text content is empty.
     * If if is, we know the email contained only images and is invalid.
     *
     * For advanced editor, uses cleanAdvancedEditorHtml to remove all tags and checks if the text content is empty.
     */
    const htmlContent = patchedFields.html_content
    if (patchedFields.compose_tool === "beefree") {
        return cleanAdvancedEditorHtml(htmlContent) === ""
    }
    return htmlContent.replace(/<img .*?>/g, "").replace(/<.+?>/g, "") === ""
}

export const containsPlaceholdersOnly = (patchedFields) => {
    /**
     * Checks that the html_content contains more than just placeholders.
     *
     * For simple editor, removes all placeholders and all tags and checks if the text content is empty.
     * If if is, we know the email contained only placeholders and is invalid.
     *
     * For advanced editor, uses cleanAdvancedEditorHtml to remove all tags.
     * Then removes all placeholders and checks if the text content is empty.
     */
    const htmlContent = patchedFields.html_content
    if (patchedFields.compose_tool === "beefree") {
        return cleanAdvancedEditorHtml(htmlContent).replace(/{{.+?}}/g, "") === ""
    }
    return htmlContent.replace(/{{.+?}}/g, "").replace(/<.+?>/g, "") === ""
}
